import React from 'react'
import { getProfitCopy } from './utils/getProfitCopy'
import * as S from './styled'

type ProfitValueProps = {
  profit: number
}

export const ProfitValue = ({ profit }: ProfitValueProps) => {
  return (
    <S.Text $value={profit} data-testid="ProfitValue">
      {getProfitCopy(profit)}
    </S.Text>
  )
}
